<template>
  <div class="simple-table">
    <table>
      <thead>
        <tr>
          <th
            v-for="column in columns"
            :key="column.name"
            :width="column.width || 'auto'"
          >
            <span>{{ column.label }}</span>
            <span v-if="order.column === column.name" class="ordering" :class="{ desc: order.desc }"/>
          </th>
          <th v-if="actions"/>
        </tr>
      </thead>
      <tbody v-if="!loading && !error">
        <tr v-for="row in list" :key="row.id" @click="$emit('rowClick', row.id)">
          <td v-for="column in columns" :key="`${column.name}-${row.id}`">
            <slot
              :name="column.name"
              v-bind:row="row"
              v-bind:value="row[column.name]"
            >{{ row[column.name] }}</slot>
          </td>
          <td v-if="actions" class="actions">
            <slot name="actions" v-bind:row="row"></slot>
          </td>
        </tr>
        <p v-if="!list.length">Нет результатов</p>
      </tbody>
    </table>
    <div class="content-loader" v-if="loading">
      <loader width="48px" height="48px" stroke="#4C4C4C"/>
    </div>
    <div v-else-if="error" class="table-error">Произошла ошибка. Пожалуйста, попробуйте еще раз.</div>
  </div>
</template>

<script>
export default {
  name: 'table-element',

  props: {
    columns: {
      required: true,
      type: Array,
    },

    list: {
      required: true,
      type: Array,
    },

    order: {
      required: true,
      type: Object,
    },

    actions: {
      required: false,
      default: false,
      type: Boolean,
    },

    loading: {
      default: false,
      type: Boolean,
    },

    error: {
      default: false,
      // eslint-disable-next-line
      type: Error | Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.simple-table {
  display: flex;
  flex-direction: column;
  flex: 1;

  th {
    user-select: none;
  }

  p {
    margin-top: 10px;
  }

  tr:has(td > .error) {
    background: #EF9A9A;
  }

  tr:has(td > .success) {
    background: #81C784;
  }
}

.table-error {
  padding: 30px;
  text-align: center;
  color: var(--sport-red-color);
}

.content-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.02);
  flex: 1;
}
</style>
